
import * as React from 'react';
import { IOverflowContainerViewProps } from '../../../modules/overflow-container/overflow-container';

const OverflowContainerView: React.FC<IOverflowContainerViewProps> = props => {
    const { btn, content, currentClass, config: { cssClassName } } = props;

    return (
        <div className={`${currentClass} ${cssClassName || ''}`}>
            {btn}
            {content}
        </div>
    );
};

export default OverflowContainerView;